// Curated cardio plans (intervals) loaded from src/data/myCardioPlans.json.
// Edit the JSON to tweak durations/speeds/levels; no DB involvement.

import data from '../data/myCardioPlans.json'

export const CARDIO_PLANS = Array.isArray(data?.plans) ? data.plans : []

export function pickPlanName(plan, lang) {
  if (lang === 'ar' && plan?.name_ar) return plan.name_ar
  return plan?.name_en || plan?.id || ''
}

export function pickPlanSubtitle(plan, lang) {
  if (lang === 'ar' && plan?.subtitle_ar) return plan.subtitle_ar
  return plan?.subtitle_en || ''
}

export function pickPlanPurpose(plan, lang) {
  if (lang === 'ar' && plan?.purpose_ar) return plan.purpose_ar
  return plan?.purpose_en || ''
}

// Materialise a plan's blocks into the shape NewSession's `cardios`
// array expects: client IDs, order_index, string-typed numeric fields.
// Caller assigns clientId/order_index — we hand back the data shape.
export function expandPlanBlocks(plan) {
  if (!plan || !Array.isArray(plan.blocks)) return []
  return plan.blocks.map((b, idx) => ({
    clientId: typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${plan.id}-${idx}`,
    cardio_type: b.cardio_type,
    order_index: idx,
    duration_min: b.duration_min != null ? String(b.duration_min) : '',
    level: b.level != null ? String(b.level) : '',
    incline: b.incline != null ? String(b.incline) : '',
    speed: b.speed != null ? String(b.speed) : '',
    distance_km: b.distance_km != null ? String(b.distance_km) : '',
    calories_estimated: b.calories_estimated != null ? String(b.calories_estimated) : '',
    notes: b.notes || '',
  }))
}
